export default __webpack_public_path__ + "static/media/avatar2.38cb94e2.svg";